import { ProductsGrid } from '@ui/product/products-grid.tsx';
import { ProductsSectionAction } from '@ui/product/products-section-action.tsx';
import { ProductCardProps } from '@ui/product/product-card.tsx';

export const ProductsSection = ({
  title,
  items = [],
  onPress,
  isShowMore = true,
}: {
  title: string;
  items?: (ProductCardProps | undefined)[];
  onPress?: () => void;
  isShowMore?: boolean;
}) => {
  return (
    <section className="flex flex-col">
      <div className="flex flex-row items-center justify-between py-3 lg:py-12">
        <h5 className="font-medium lg:font-bold lg:text-4xl text-base text-[#222222]">
          {title}
        </h5>

        {isShowMore && (
          <ProductsSectionAction
            text="Все"
            largeText="Смотреть все"
            onPress={onPress}
          />
        )}
      </div>

      <ProductsGrid items={items} />
    </section>
  );
};
